import Vue from "vue";

export default {
  config: (state, {
    productType,
    countryCode,
    tosPath,
    trialDays,
    countryOptions,
    isIosAppPurchase,
    isInVariation
  }) => {
    Vue.set(state, "productType", productType);
    Vue.set(state, "countryCode", countryCode);
    Vue.set(state, "tosPath", tosPath);
    Vue.set(state, "trialDays", trialDays);
    Vue.set(state, "countryOptions", countryOptions);
    Vue.set(state, "isIosAppPurchase", isIosAppPurchase);
    Vue.set(state, "isInVariation", isInVariation);
  },
  plan: (state, payload = {}) => {
    Vue.set(state, "plan", payload);
  },
  error: (state, payload) => {
    state.error = payload;
  },
  showThreeDs: (state, payload) => {
    state.showThreeDs = payload;
  },
  loading: (state, payload) => {
    state.loading = payload;
  },
  sending: (state, payload) => {
    state.sending = payload;
  },
  coupon: (state, payload) => {
    Vue.set(state, "coupon", {
      ...state.coupon,
      ...payload
    });
  },
  zip: (state, payload) => {
    Vue.set(state, "zip", {
      ...state.zip,
      ...payload
    });
  },
  countryCode: (state, payload) => {
    state.countryCode = payload;
  },
  giftcard: (state, payload) => {
    Vue.set(state, "giftcard", {
      ...state.giftcard,
      ...payload
    });
  },
  tax: (state, { amount, region } = {}) => {
    Vue.set(state, "tax", {
      amount,
      region
    });
  },
  selectedPaymentMethod: (state, payload) => {
    state.selectedPaymentMethod = payload;
  }
};
